import React, { useRef, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { MultiSelect } from '@frontend/pole-ui/lib/components/MultiSelect'
import { useGetAgentRegions } from '@/components/composed/financing/useGetAgentRegions'
import { TextInput } from '@/components/ui/ReactHookFormFields'
import type { IAgentRegistrationRequestFormValues } from '@/types/IAgentRegistrationRequestFormValues'
import { messages } from './messages'
import type { IAgentRegistrationFormProps } from './types'
import './styles.scss'

export const AgentRegistrationFields: React.FC<IAgentRegistrationFormProps> = props => {
  const { className, classNameRegionFiled } = props
  const [selectedRegionCodes, setSelectedRegionCodes] = useState<string[]>([])

  const { filteredRegions, regionsData } = useGetAgentRegions()

  const containerRef = useRef<HTMLDivElement>(null)
  const { control } = useFormContext<IAgentRegistrationRequestFormValues>()

  return (
    <div className={className}>
      <TextInput
        control={control}
        name="name"
        type="text"
        isRequired
        rules={{ required: messages.errors.required }}
        placeholder={messages.labels.name}
        shouldBeTouchedBeforeError={false}
      />
      <TextInput
        control={control}
        name="phone"
        type="tel"
        isRequired
        rules={{ required: messages.errors.required }}
        placeholder={messages.labels.phone}
        shouldBeTouchedBeforeError={false}
      />
      <TextInput
        control={control}
        name="email"
        type="email"
        isRequired
        rules={{ required: messages.errors.required }}
        placeholder={messages.labels.email}
        shouldBeTouchedBeforeError={false}
      />
      <div className="agentRegistrationFields__regions" ref={containerRef}>
        <Controller
          name="regions"
          control={control}
          rules={{ required: messages.errors.required }}
          render={({ field: { onChange }, formState: { errors } }) => (
            <MultiSelect
              value={selectedRegionCodes}
              className={classNameRegionFiled}
              placeholder={messages.labels.regions}
              options={filteredRegions}
              onChange={newValue => {
                setSelectedRegionCodes(newValue)
                const selectedRegions = regionsData.filter(region => newValue.includes(String(region.code)))
                onChange(selectedRegions)
              }}
              error={errors.regions?.message}
              container={containerRef.current ?? undefined}
            />
          )}
        />
      </div>
    </div>
  )
}
